import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { NextrackerLayoutOptions, ZimmermanLayoutOptions } from './constant';

const LayoutDropdown = ({ showType, onShowTypeChange, projectType }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (type) => {
    onShowTypeChange(type);
    handleClose();
  };


  const layoutOptions = projectType === "Nexttracker" ? NextrackerLayoutOptions : ZimmermanLayoutOptions
  const currentLabel = layoutOptions.find(option => option.value === showType)?.label || 'Pier Map';

  return (
    <Box>
      <Button
        variant="contained"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon sx={{ flexShrink: 0 }} />}
        sx={{
          backgroundColor: '#f16253',
          color: 'white',
          textTransform: 'none',
          px: 1.5,
          py: 0.75,
          fontSize: '14px',
          fontWeight: 500,
          width: '90px', // Fixed width
          justifyContent: 'space-between',
          '&:hover': {
            backgroundColor: '#d9574a',
          },
          '& .MuiButton-endIcon': {
            marginLeft: 'auto',
            marginRight: 0,
          }
        }}
      >
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '90px', // Leave space for the icon
          }}
        >
          {currentLabel}
        </Box>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 0.5,
            minWidth: 150,
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
          }
        }}
      >
        {layoutOptions.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleMenuItemClick(option.value)}
            selected={showType === option.value}
            sx={{
              fontSize: '14px',
              '&.Mui-selected': {
                backgroundColor: '#f5f5f5',
              }
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LayoutDropdown;